module.exports = __webpack_public_path__ + "static/media/1022104.8b364a7a.jpg";